export default __webpack_public_path__ + "static/media/400-error.ce78fb1c.svg";